<template>
    <div>
        <span class="text-right" v-if="data.is_canceled"><span class="badge badge-dark-hard">DI BATALKAN</span></span>
        <span class="text-right" v-else-if="data.status == 'SUCCESS'"><span class="badge badge-success">SUKSES</span></span>
        <span class="text-right" v-else-if="data.status == 'PENDING'"><span class="badge badge-warning">MENUNGGU PEMBAYARAN</span></span>
        <span class="text-right" v-else-if="data.status == 'WAITING_PROCESS'"><span class="badge badge-primary">MENUNGGU PERSETUJUAN</span></span>
        <span class="text-right" v-else-if="data.status == 'WAITING_CONFIRMATION'"><span class="badge badge-dark">DRAFT</span></span>
        <span class="text-right" v-else><span class="badge badge-danger">EXPIRED</span></span>
    </div>
</template>

<script>
export default {
    props: [
        'data'
    ]
}
</script>

<style>

</style>